import { ApiResponseNHL, useFetchLeagueData } from '~/core/api';

import { PlayoffSeries } from './types';

export const usePlayoffSeriesQuery = ({
    season,
    seriesLetter,
}: {
    season: string;
    seriesLetter: string;
}): ApiResponseNHL<PlayoffSeries> => useFetchLeagueData(`/schedule/playoff-series/${season}/${seriesLetter}/`);
